import { ConfigurationDataType } from 'src/clientConfiguration';
import { ConsentBlockingBehaviour, ConsentType } from './types';

export const DEFAULT_DATA_FILE_CONFIGURATION: ConfigurationDataType = {
  customData: [],
  featureFlags: [],
  configuration: {
    realTimeUpdate: false,
    consentType: ConsentType.NotRequired,
    dataApiDomain: 'data.kameleoon.io',
    consentOptOutBehavior: ConsentBlockingBehaviour.PartiallyBlocked,
  },
};
